import $ from 'jquery';
export function initAgenda() {
    $(document).ready(function () {
        $('.js-agenda-collapsible').on('click', function (event) {
            event.preventDefault();
            $(this).parents('.agenda-content').toggleClass('open');
        });
    });
}
